module.exports = __webpack_public_path__ + "b5238521284309684bfd3184d62c72c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/comment.png
// module id = 210
// module chunks = 0